module.exports = __webpack_public_path__ + "media/src/images/top_covers/com_autumn_04-60887738c9b0092a20e4f3f60ea8fd28.png";